import { useRef } from "react";
import { useSnackbar } from "notistack";

export const useErrorSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const errorShownRef = useRef(false);
  const snackbarKeyRef = useRef<string | number | null>(null);

  const showError = (message: string) => {
    if (!errorShownRef.current) {
      errorShownRef.current = true;
      snackbarKeyRef.current = enqueueSnackbar(message || "Something went wrong!", {
        variant: "error",
        preventDuplicate: true,
        persist: false,
        autoHideDuration: 6000,
        onClose: () => {
          errorShownRef.current = false;
          snackbarKeyRef.current = null;
        },
      });
    }
  };

  const clearError = () => {
    if (snackbarKeyRef.current) {
      closeSnackbar(snackbarKeyRef.current);
      errorShownRef.current = false;
      snackbarKeyRef.current = null;
    }
  };

  return { showError, clearError };
};
